<template lang="pug">
  #app
    header-component
    transition(name="fade")
      router-view
    notifications
</template>

<script>
  import HeaderComponent from './components/Header_Not_Logged.vue'
  export default {
    components: {
      HeaderComponent
    },
    name: 'app'
  }
</script>

<style lang="stylus">

  $yellow = #ffdd57

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%
    background-color #f9f9f9
  }

  html, body {
    height: 100%
    margin 0
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .half-width
    width 50%
  
  .margin-auto
    margin auto
  
  .cursor
    cursor pointer
</style>



// WEBPACK FOOTER //
// Not_Logged_App.vue?bee4d4a2